import { render, staticRenderFns } from "./MonthTab.vue?vue&type=template&id=053565bf&scoped=true"
import script from "./MonthTab.vue?vue&type=script&lang=js"
export * from "./MonthTab.vue?vue&type=script&lang=js"
import style0 from "./MonthTab.vue?vue&type=style&index=0&id=053565bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053565bf",
  null
  
)

export default component.exports